/**
 * Etiquetas amigables (caso natural) del tipo y subtipo de solicitud, para mostrar
 * los enums crudos del backend de forma legible. Ej. "ContratoAnualizado" →
 * "Contrato anualizado", "CFDI_UNICO" → "CFDI Único".
 *
 * Nota: el listado "Mis solicitudes" usa sus propias etiquetas en MAYÚSCULAS por el
 * estilo de esa tabla; estas son las de caso natural (bandeja de autorización, etc.).
 */

const TIPOS: Record<string, string> = {
  FB60: "FB60",
  ContratoAnualizado: "Contrato anualizado",
  OrdenDeCompra: "Orden de compra",
};

const SUBTIPOS: Record<string, string> = {
  CFDI_UNICO: "CFDI Único",
  MULTIPLES_CFDI: "Múltiples CFDI",
  CONTRAPAGO: "Contrapago",
};

export function etiquetaTipoSolicitud(tipo: string | null | undefined): string {
  if (!tipo) return "—";
  return TIPOS[tipo] ?? tipo;
}

export function etiquetaSubtipoSolicitud(subtipo: string | null | undefined): string {
  if (!subtipo) return "—";
  return SUBTIPOS[subtipo] ?? subtipo.replace(/_/g, " ");
}
